import { useContext } from 'react';
import OATContext from './oat-context';

interface Socket {
  emit: <T = any>(message: string, payload?: T) => void;
  changeState: (message: string, payload?: any) => void;
}

export interface OatData<T> {
  socket: Socket;
  currentState?: string;
  error?: any;
  data: T;
  features?: GatsbyTypes.configFeatures;
  queryTableStatus: (
    restaurantId: string,
    paymentMode: boolean,
    urlSearchParams: URLSearchParams,
    joinTable: boolean
  ) => void;
  joinTable: (restaurantId, paymentMode, tableNumber) => void;
  initialStorage?: any;
  clientId?: string;
  setIsLoading: (bool: boolean) => void;
  isLoading?: boolean;
  isRedundant?: boolean;
  restaurantId?: string;
  getItemImageData: (itemId: string) => any;
}

const useOAT = <T = any>() => {
  const oatData = useContext<OatData<T>>(OATContext);
  return oatData;
};

export default useOAT;
